export default ({ request }) => ({
  sampleSetInfoCopyDetailApi(data = {}) {
    return request({
      url: '/master/sample/set/info/copy/detail',
      method: 'post',
      data,
    })
  },
  sampleSetImageListApi(data = {}) {
    return request({
      url: '/master/sample/set/image/list',
      method: 'post',
      data,
    })
  },
  sampleSetImageDelApi(data = {}) {
    return request({
      url: '/master/sample/set/image/del',
      method: 'post',
      data,
    })
  },
  sampleSetImageBatchUploadApi(data = {}) {
    return request({
      url: '/master/sample/set/image/batch/upload',
      method: 'post',
      data,
    })
  },
  sampleSetImageDefaultImageApi(data = {}) {
    return request({
      url: '/master/sample/set/image/defaultImage',
      method: 'post',
      data,
    })
  },
  sampleSetImageUpdateSortOrderApi(data = {}) {
    return request({
      url: '/master/sample/set/image/update/sortOrder',
      method: 'post',
      data,
    })
  },
  sampleSetMaterialListApi(data = {}) {
    return request({
      url: '/master/sample/set/material/list',
      method: 'post',
      data,
    })
  },
  sampleSetMaterialDetailApi(data = {}) {
    return request({
      url: '/master/sample/set/material/detail',
      method: 'post',
      data,
    })
  },
  sampleSetMaterialSaveApi(data = {}) {
    return request({
      url: '/master/sample/set/material/save',
      method: 'post',
      data,
    })
  },
  sampleSetMaterialDelApi(data = {}) {
    return request({
      url: '/master/sample/set/material/del',
      method: 'post',
      data,
    })
  },
  sampleSetMaterialUpdateSortApi(data = {}) {
    return request({
      url: '/master/sample/set/material/updateSort',
      method: 'post',
      data,
    })
  },
  sampleSetMaterialUpdateCostPriceApi(data = {}) {
    return request({
      url: '/master/sample/set/material/update/costPrice',
      method: 'post',
      data,
    })
  },
})
